/**
 * @generated SignedSource<<ff8837bfed0b40c4f89e32c942f73757>>
 * @relayHash c289897f1e14277fabf9db0f916cc09d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6c0389bb5e4375145c6e0876f0f6dbc76f0abe1939e45fa57cf30e534bd669cd

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { CustomerDetailsCustomerDetailsPageQuery } from './CustomerDetailsCustomerDetailsPageQuery.graphql';

const node: PreloadableConcreteRequest<CustomerDetailsCustomerDetailsPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "6c0389bb5e4375145c6e0876f0f6dbc76f0abe1939e45fa57cf30e534bd669cd",
    "metadata": {},
    "name": "CustomerDetailsCustomerDetailsPageQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
